import React, { Component } from 'react'
import Loader from "../Shared/Loader/loader";
import { InProgressComponent, SavingComponent } from './SavingComponent';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { accessMap } from './accessMap';
import { RoleContext } from './Context/RoleContext';
import { GlobalContext } from "../../Renderers/GlobalContext"
import { withTranslation } from 'react-i18next';
import { updateEntity } from "../../API/Entity/Entity"

class OthersRights extends Component {

    static contextType = RoleContext

    constructor(props) {
        super(props)
    }

    componentDidMount = async () => {
        const { dispatch } = this.context;
        const { listData, chartsData } = this.getData();
        dispatch({ type: "" })
        dispatch({ type: "SET_OTHER_RIGHTS", payload: { listData, chartsData } })
        dispatch({ type: "SET_OTHER_RIGHTS_LOADER", payload: false })
    }

    componentDidUpdate = async (props) => {
        if (props.selectedEntity && props.selectedEntity._id !== this.props.selectedEntity._id) {
            const { dispatch } = this.context;
            const { listData, chartsData } = this.getData();
            dispatch({ type: "" })
            dispatch({ type: "SET_OTHER_RIGHTS", payload: { listData, chartsData } })
            dispatch({ type: "SET_OTHER_RIGHTS_LOADER", payload: false })
        }
    }

    render() {
        const { state } = this.context
        const { t } = this.props
        if (state.loadingOtherRights) return <Loader />
        return (
            <GlobalContext.Consumer>
                {value => (
                    <div className="mt-4 checkGenRole">
                        <div className="row">
                            <div className='col-12'>
                                <div className='row ps-2 pb-1'>
                                    <div className='col-6'>
                                        <strong>
                                            {t("list_rights.title")}
                                        </strong>
                                        <p className='text-secondary'>
                                            {t("list_rights.description")}
                                        </p>
                                    </div>
                                    <div className="col-4">
                                        <DropDownList
                                            disabled={(
                                                !this.context.state.selectedEntity.roleRights[this.context.state.selectedRole._id].read ||
                                                state.otherRightsInProgressItems.includes(state.listData.id) ||
                                                value.state.subscription.rolesPermission === "Read only"
                                            )}
                                            data={this.getAccessDataMap()}
                                            value={this.getAccessValue(state.listData)}
                                            onChange={this.handleListRights}
                                            textField={"text"}
                                        />
                                    </div>
                                    <div className="col-2">
                                        {state.otherRightsInProgressItems.includes(state.listData.id) && <InProgressComponent />}
                                        {state.otherRightsSavedItems.includes(state.listData.id) && <SavingComponent />}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className='col-12'>
                                <div className='row ps-2 pb-1'>
                                    <div className='col-6'>
                                        <strong>
                                            {t("charts_rights.title")}
                                        </strong>
                                        <p className='text-secondary'>
                                            {t("charts_rights.description")}
                                        </p>
                                    </div>
                                    <div className="col-4">
                                        <DropDownList
                                            disabled={(
                                                !this.context.state.selectedEntity.roleRights[this.context.state.selectedRole._id].read ||
                                                state.otherRightsInProgressItems.includes(state.chartsData.id) ||
                                                value.state.subscription.rolesPermission === "Read only"
                                            )}
                                            data={this.getAccessDataMap()}
                                            value={this.getAccessValue(state.chartsData)}
                                            onChange={this.handleChartsRights}
                                            textField={"text"}
                                        />
                                    </div>
                                    <div className='col-2'>
                                        {state.otherRightsInProgressItems.includes(state.chartsData.id) && <InProgressComponent />}
                                        {state.otherRightsSavedItems.includes(state.chartsData.id) && <SavingComponent />}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </GlobalContext.Consumer>
        )
    }

    getData = () => {
        const { selectedRole, selectedEntity } = this.context.state
        const { accessLists, accessCharts, manageLists, manageCharts } = selectedEntity.roleRights[selectedRole._id];
        const listData = {
            access: accessLists,
            manage: manageLists,
            id: "list-data-" + this.props.selectedEntity._id
        };
        const chartsData = {
            access: accessCharts,
            manage: manageCharts,
            id: "charts-data-" + this.props.selectedEntity._id
        };
        return {
            listData,
            chartsData
        }
    }

    getAccessDataMap = () => {
        const { t } = this.props
        const accessMapData = accessMap.map(item => {
            const key = item.key.toLowerCase().split(" ").join("_")
            const text = t("dropdown_values." + key)
            return {
                ...item,
                text
            }
        })
        return accessMapData
    }

    getAccessValue = ({ access, manage }) => {
        if (access && manage) {
            return this.getAccessValueMap(accessMap[0])
        } else if (access && !manage) {
            return this.getAccessValueMap(accessMap[1])
        } else {
            return this.getAccessValueMap(accessMap[2])
        }
    }

    getAccessValueMap(accessMapData) {
        const { t } = this.props;
        const key = accessMapData.key.toLowerCase().split(" ").join("_");
        const text = t("dropdown_values." + key);
        return {
            ...accessMapData,
            text
        };
    }

    handleListRights = async (event) => {
        const { state, dispatch } = this.context
        const { selectedRole, selectedEntity } = state
        dispatch({ type: "OTHER_ADD_TO_INPROGRESS", payload: state.listData.id })
        const permission = accessMap.find(item => item.key === event.value.key);
        let { roleRights } = selectedEntity
        roleRights[selectedRole._id] = {
            ...roleRights[selectedRole._id],
            accessLists: permission.entity.accessLists,
            manageLists: permission.entity.manageLists
        }
        await updateEntity(selectedEntity._id, { roleRights })
        dispatch({ type: "UPDATE_LIST_RIGHTS", payload: { access: permission.entity.accessLists, manage: permission.entity.manageLists } })
        dispatch({ type: "OTHER_MOVE_TO_SAVE", payload: state.listData.id })
    }

    handleChartsRights = async (event) => {
        const { state, dispatch } = this.context
        const { selectedRole, selectedEntity } = state
        dispatch({ type: "OTHER_ADD_TO_INPROGRESS", payload: state.chartsData.id })
        const permission = accessMap.find(item => item.key === event.value.key);
        let { roleRights } = selectedEntity
        roleRights[selectedRole._id] = {
            ...roleRights[selectedRole._id],
            accessCharts: permission.entity.accessCharts,
            manageCharts: permission.entity.manageCharts
        }
        await updateEntity(selectedEntity._id, { roleRights })
        dispatch({ type: "UPDATE_CHARTS_RIGHTS", payload: { access: permission.entity.accessCharts, manage: permission.entity.manageCharts } })
        dispatch({ type: "OTHER_MOVE_TO_SAVE", payload: state.chartsData.id })
    }
}

export default withTranslation([
    "role/others_rights",
], {
    withRef: true,
})(OthersRights);
